import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92cd0b5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "writing-board-tool" }
const _hoisted_2 = { class: "tool-content" }
const _hoisted_3 = { class: "size" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "墨迹粗细：", -1))
const _hoisted_5 = { class: "size" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "墨迹粗细：", -1))
const _hoisted_7 = { class: "size" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "橡皮大小：", -1))
const _hoisted_9 = { class: "colors" }
const _hoisted_10 = ["onClick"]

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useSlidesStore } from '@/store'
import { db } from '@/utils/database'

import WritingBoard from '@/components/WritingBoard.vue'
import MoveablePanel from '@/components/MoveablePanel.vue'
import Slider from '@/components/Slider.vue'
import Popover from '@/components/Popover.vue'

type WritingBoardModel = 'pen' | 'mark' | 'eraser'


export default /*#__PURE__*/_defineComponent({
  __name: 'WritingBoardTool',
  props: {
    slideWidth: {},
    slideHeight: {},
    left: { default: -5 },
    top: { default: -5 }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

const writingBoardColors = ['#000000', '#ffffff', '#1e497b', '#4e81bb', '#e2534d', '#9aba60', '#8165a0', '#47acc5', '#f9974c', '#ffff3a']



const emit = __emit

const { currentSlide } = storeToRefs(useSlidesStore())

const writingBoardRef = ref<InstanceType<typeof WritingBoard>>()
const writingBoardColor = ref('#e2534d')
const writingBoardModel = ref<WritingBoardModel>('pen')
const blackboard = ref(false)
const sizePopoverType = ref<'' | WritingBoardModel>('')

const penSize = ref(6)
const markSize = ref(24)
const rubberSize = ref(80)

const changeModel = (model: WritingBoardModel) => {
  if (writingBoardModel.value === model) {
    sizePopoverType.value = sizePopoverType.value === model ? '' : model
  }
  else {
    if (sizePopoverType.value) sizePopoverType.value = ''
    writingBoardModel.value = model
  }
}

// 清除画布上的墨迹
const clearCanvas = () => {
  writingBoardRef.value!.clearCanvas()
}

// 修改画笔颜色，如果当前处于橡皮状态则先切换到画笔状态
const changeColor = (color: string) => {
  if (writingBoardModel.value === 'eraser') writingBoardModel.value = 'pen'
  writingBoardColor.value = color
}

// 关闭写字板
const closeWritingBoard = () => {
  emit('close')
}

// 打开画笔工具或切换页面时，将数据库中存储的墨迹绘制到画布上
watch(currentSlide, () => {
  db.writingBoardImgs.where('id').equals(currentSlide.value.id).toArray().then(ret => {
    const currentImg = ret[0]
    writingBoardRef.value!.setImageDataURL(currentImg?.dataURL || '')
  })
}, { immediate: true })

// 每次绘制完成后将绘制完的图片更新到数据库
const hanldeWritingEnd = () => {
  const dataURL = writingBoardRef.value!.getImageDataURL()
  if (!dataURL) return

  db.writingBoardImgs.where('id').equals(currentSlide.value.id).toArray().then(ret => {
    const currentImg = ret[0]
    if (currentImg) db.writingBoardImgs.update(currentImg, { dataURL })
    else db.writingBoardImgs.add({ id: currentSlide.value.id, dataURL })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_IconWrite = _resolveComponent("IconWrite")!
  const _component_IconHighLight = _resolveComponent("IconHighLight")!
  const _component_IconErase = _resolveComponent("IconErase")!
  const _component_IconClear = _resolveComponent("IconClear")!
  const _component_IconFill = _resolveComponent("IconFill")!
  const _component_IconClose = _resolveComponent("IconClose")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "writing-board-wrap",
      style: _normalizeStyle({
        width: _ctx.slideWidth + 'px',
        height: _ctx.slideHeight + 'px',
      })
    }, [
      _createVNode(WritingBoard, {
        ref_key: "writingBoardRef",
        ref: writingBoardRef,
        color: writingBoardColor.value,
        blackboard: blackboard.value,
        model: writingBoardModel.value,
        penSize: penSize.value,
        markSize: markSize.value,
        rubberSize: rubberSize.value,
        onEnd: _cache[0] || (_cache[0] = ($event: any) => (hanldeWritingEnd()))
      }, null, 8, ["color", "blackboard", "model", "penSize", "markSize", "rubberSize"])
    ], 4),
    _createVNode(MoveablePanel, {
      class: "tools-panel",
      width: 520,
      height: 50,
      left: _ctx.left,
      top: _ctx.top,
      moveable: sizePopoverType.value === ''
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "tools",
          onMousedown: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(Popover, {
              trigger: "manual",
              value: sizePopoverType.value === 'pen'
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(Slider, {
                    class: "size-slider",
                    min: 4,
                    max: 10,
                    step: 2,
                    value: penSize.value,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((penSize).value = $event))
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'pen' }]),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (changeModel('pen')))
                }, [
                  _createVNode(_component_IconWrite, { class: "icon" })
                ], 2)), [
                  [_directive_tooltip, '画笔']
                ])
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(Popover, {
              trigger: "manual",
              value: sizePopoverType.value === 'mark'
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(Slider, {
                    class: "size-slider",
                    min: 16,
                    max: 40,
                    step: 4,
                    value: markSize.value,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((markSize).value = $event))
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'mark' }]),
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (changeModel('mark')))
                }, [
                  _createVNode(_component_IconHighLight, { class: "icon" })
                ], 2)), [
                  [_directive_tooltip, '荧光笔']
                ])
              ]),
              _: 1
            }, 8, ["value"]),
            _createVNode(Popover, {
              trigger: "manual",
              value: sizePopoverType.value === 'eraser'
            }, {
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createVNode(Slider, {
                    class: "size-slider",
                    min: 20,
                    max: 200,
                    step: 20,
                    value: rubberSize.value,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((rubberSize).value = $event))
                  }, null, 8, ["value"])
                ])
              ]),
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["btn", { 'active': writingBoardModel.value === 'eraser' }]),
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (changeModel('eraser')))
                }, [
                  _createVNode(_component_IconErase, { class: "icon" })
                ], 2)), [
                  [_directive_tooltip, '橡皮擦']
                ])
              ]),
              _: 1
            }, 8, ["value"]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: "btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (clearCanvas()))
            }, [
              _createVNode(_component_IconClear, { class: "icon" })
            ])), [
              [_directive_tooltip, '清除墨迹']
            ]),
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["btn", { 'active': blackboard.value }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (blackboard.value = !blackboard.value))
            }, [
              _createVNode(_component_IconFill, { class: "icon" })
            ], 2)), [
              [_directive_tooltip, '黑板']
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(writingBoardColors, (color) => {
                return _createElementVNode("div", {
                  class: _normalizeClass(["color", { 'active': color === writingBoardColor.value }]),
                  key: color,
                  style: _normalizeStyle({ backgroundColor: color }),
                  onClick: ($event: any) => (changeColor(color))
                }, null, 14, _hoisted_10)
              }), 64))
            ])
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (closeWritingBoard()))
          }, [
            _createVNode(_component_IconClose, { class: "icon" })
          ])), [
            [_directive_tooltip, '关闭画笔']
          ])
        ], 32)
      ]),
      _: 1
    }, 8, ["left", "top", "moveable"])
  ]))
}
}

})